import { render, staticRenderFns } from "./TarefaRequisicaoForm.vue?vue&type=template&id=73b2f937&scoped=true"
import script from "./TarefaRequisicaoForm.vue?vue&type=script&lang=js"
export * from "./TarefaRequisicaoForm.vue?vue&type=script&lang=js"
import style0 from "./TarefaRequisicaoForm.vue?vue&type=style&index=0&id=73b2f937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b2f937",
  null
  
)

export default component.exports